import React from 'react'

const UserChats = () => {
  return (
    <div>
      <h1>UserChats</h1>
    </div>
  )
}

export default UserChats
